module.exports = __webpack_public_path__ + "static/media/background_1.3166137e.mp3";